<div class="glxy-sticky-footer-content">
  <div class="glxy-sticky-footer-primary">
    <ng-content />
  </div>
  <ng-content select="glxy-sticky-footer-secondary, [glxyStickyFooterSecondary]" />
</div>
